(() => {
  'use strict';
  const rawConfig = document.getElementById('LucyConfig');
  if (!rawConfig) return;
  const config = JSON.parse(rawConfig.textContent);
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency || 'USD' }).format(Number(cents || 0) / 100);
  const bag = document.getElementById('LucyBag');
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  let busy = false;
  let cartRevision = 0;
  let lastOpener = null;

  // Preview storage is isolated from Shopify. Production always uses the native Ajax Cart API.
  const previewKey = 'lucy-us-design-preview-v1';
  function previewCart(path, payload) {
    let items = [];
    try { items = JSON.parse(localStorage.getItem(previewKey) || '[]'); } catch { /* Storage may be disabled. */ }
    if (!Array.isArray(items)) items = [];
    const catalog = config.previewProducts || [];
    items = items.filter(item => catalog.some(p => p.id === item.id) && Number.isInteger(item.quantity) && item.quantity > 0);
    if (path === 'cart/add.js') {
      for (const added of payload.items) {
        const product = catalog.find(p => p.id === Number(added.id));
        if (!product || !product.available) throw new Error('This item is currently unavailable. Please choose another option.');
        const current = items.find(item => item.id === product.id);
        if (current) current.quantity += added.quantity;
        else items.push({ id: product.id, quantity: added.quantity });
      }
    }
    if (path === 'cart/change.js') {
      const item = items.find(p => 'preview-' + p.id === payload.id);
      if (item) item.quantity = payload.quantity;
      items = items.filter(p => p.quantity > 0);
    }
    try { localStorage.setItem(previewKey, JSON.stringify(items)); } catch { /* A preview can run without storage. */ }
    const lines = items.map(item => {
      const product = catalog.find(p => p.id === item.id);
      return { ...product, quantity: item.quantity, key: 'preview-' + item.id, product_title: product.title, final_price: product.price, final_line_price: product.price * item.quantity, image: product.image, url: product.url };
    });
    return { items: lines, item_count: lines.reduce((sum, item) => sum + item.quantity, 0), total_price: lines.reduce((sum, item) => sum + item.final_line_price, 0), currency: 'USD' };
  }
  async function requestCart(path, payload) {
    if (config.preview) return previewCart(path, payload);
    const root = window.Shopify?.routes?.root || config.root || '/';
    const response = await fetch(root.replace(/\/?$/, '/') + path, {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('We could not load your bag. Please try again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We could not update your bag. Please try again.');
    return data;
  }
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function safeUrl(value) {
    try { const u = new URL(value, location.href); return ['https:', 'http:', 'file:'].includes(u.protocol) ? value : '#'; } catch { return '#'; }
  }
  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    const items = qs('[data-cart-items]');
    items.replaceChildren();
    qs('[data-cart-summary]').hidden = cart.item_count === 0;
    qs('[data-cart-total]').textContent = money(cart.total_price);
    const shipping = qs('[data-cart-shipping]');
    shipping.textContent = '';
    if (cart.item_count && config.shippingEnabled && config.currency === 'USD') {
      const left = config.shippingThreshold - cart.total_price;
      shipping.textContent = left > 0 ? `${money(left)} away from free standard US shipping.` : 'Your bag qualifies for free standard US shipping.';
    }
    if (!cart.item_count) {
      const empty = el('div', 'cart-empty');
      empty.append(el('h3', '', 'A little care starts here.'), el('p', '', 'Your bag is empty. Find your everyday balm.'));
      items.append(empty);
    }
    cart.items.forEach(item => {
      const row = el('article', 'cart-item');
      const photo = el('img', 'cart-item-image');
      photo.src = safeUrl(item.image || ''); photo.alt = item.product_title; photo.width = 85; photo.height = 110;
      const content = el('div');
      const title = el('a', 'cart-item-title', item.product_title);
      title.href = safeUrl(item.url);
      content.append(title, el('p', 'cart-item-price', money(item.final_line_price)));
      const controls = el('div', 'cart-item-controls');
      const stepper = el('div', 'quantity-stepper');
      stepper.setAttribute('role', 'group'); stepper.setAttribute('aria-label', `Quantity for ${item.product_title}`);
      const minus = el('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', `Decrease quantity of ${item.product_title}`);
      const plus = el('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', `Increase quantity of ${item.product_title}`);
      const rule = (config.qtyRules || {})[String(item.variant_id || item.id)] || { min: 1, step: 1 };
      const step = Math.max(1, Number(rule.step) || 1);
      const minQty = Math.max(1, Number(rule.min) || 1);
      minus.addEventListener('click', () => { const next = item.quantity - step; changeQuantity(item.key, next < minQty ? 0 : next); });
      plus.addEventListener('click', () => changeQuantity(item.key, item.quantity + step));
      stepper.append(minus, el('span', '', item.quantity), plus);
      const remove = el('button', 'remove-item', 'Remove'); remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${item.product_title}`);
      remove.addEventListener('click', () => changeQuantity(item.key, 0));
      controls.append(stepper, remove); content.append(controls); row.append(photo, content); items.append(row);
    });
    document.dispatchEvent(new CustomEvent('lucy:cart-updated', { detail: { cart } }));
  }
  function setBusy(value) {
    busy = value;
    bag.setAttribute('aria-busy', String(value));
    qsa('.cart-item button, [data-checkout-form] button').forEach(button => { button.disabled = value; });
  }
  function cartFailure(message) {
    const status = qs('[data-cart-status]'); status.textContent = message + ' ';
    if (!config.preview) {
      const fallback = el('a', '', 'Open the full bag'); fallback.href = config.cartUrl || '/cart'; status.append(fallback);
    }
  }
  async function changeQuantity(key, quantity) {
    if (busy) return;
    cartRevision++;
    setBusy(true); qs('[data-cart-status]').textContent = 'Updating your bag…';
    try {
      const cart = await requestCart('cart/change.js', { id: key, quantity });
      renderCart(cart); qs('[data-cart-status]').textContent = 'Bag updated.';
    } catch (error) { cartFailure(error.message); }
    finally { setBusy(false); }
  }
  function revealBag(opener) {
    lastOpener = opener || document.activeElement;
    if (!bag.open) bag.showModal();
    qs('[data-cart-close]', bag).focus();
  }
  async function openBag(event) {
    if (event) event.preventDefault();
    revealBag(event?.currentTarget);
    if (busy) return;
    const revision = cartRevision;
    qs('[data-cart-status]').textContent = 'Loading your bag…';
    try { const cart = await requestCart('cart.js'); if (revision === cartRevision) { renderCart(cart); qs('[data-cart-status]').textContent = ''; } }
    catch (error) { cartFailure(error.message); }
  }
  qsa('[data-cart-open]').forEach(link => link.addEventListener('click', openBag));
  qsa('[data-cart-close]').forEach(button => button.addEventListener('click', () => bag.close()));
  bag.addEventListener('close', () => lastOpener?.focus?.());
  bag.addEventListener('click', event => {
    const rect = bag.getBoundingClientRect();
    if (event.target === bag && (event.clientX < rect.left || event.clientX > rect.right)) bag.close();
  });
  function syncSelection(form) {
    const selected = qs('input[name="id"]:checked', form);
    const button = qs('[data-add-button]', form);
    if (!selected) return;
    const min = Math.max(1, Number(selected.dataset.qtyMin) || 1);
    const unit = Number(selected.dataset.price);
    qs('[data-add-label]', form).textContent = selected.disabled ? 'Currently sold out' : (min > 1 ? `Add ${min} — ${money(unit * min)}` : `Add to bag — ${money(unit)}`);
    const quantityInput = qs('input[name="quantity"]', form);
    if (quantityInput) quantityInput.value = min;
    button.disabled = selected.disabled;
    qs('[data-sticky-price]').textContent = money(unit * min);
    const packLabel = selected.dataset.label === 'Two jars' ? 'Two jars · 2 × 4 fl oz' : 'One jar · 4 fl oz';
    qs('[data-sticky-detail]').textContent = min > 1 ? `${min} × ${packLabel}` : packLabel;
    qs('[data-sticky-add]').disabled = selected.disabled;
  }
  qsa('[data-purchase]').forEach(form => {
    syncSelection(form);
    form.addEventListener('change', () => { syncSelection(form); qs('[data-form-message]', form).textContent = ''; });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const selected = qs('input[name="id"]:checked', form);
      if (!selected || selected.disabled) return;
      const quantity = Math.max(1, Number(selected.dataset.qtyMin) || 1);
      const button = qs('[data-add-button]', form);
      const status = qs('[data-form-message]', form);
      setBusy(true); button.disabled = true; qs('[data-sticky-add]').disabled = true;
      qs('[data-add-label]', form).textContent = 'Adding a little care…'; status.textContent = '';
      let added = false;
      cartRevision++;
      try {
        await requestCart('cart/add.js', { items: [{ id: Number(selected.value), quantity }] });
        added = true;
        // Local event only. No tracking request or duplicate purchase event is sent by this theme.
        document.dispatchEvent(new CustomEvent('lucy:add-to-cart', { detail: { variantId: Number(selected.value), quantity, currency: config.currency } }));
        renderCart(await requestCart('cart.js'));
        qs('[data-cart-status]').textContent = '';
        revealBag(button);
      } catch (error) {
        if (added) { revealBag(button); cartFailure('Your item was added, but we could not refresh the bag.'); }
        else status.textContent = error.message;
      } finally { setBusy(false); syncSelection(form); }
    });
  });
  const mainForm = qs('[data-purchase]');
  if (mainForm) {
    const sticky = qs('[data-sticky-buy]');
    qs('[data-sticky-add]').addEventListener('click', () => mainForm.requestSubmit());
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
    observer.observe(qs('[data-add-button]', mainForm));
  }
  qsa('[data-gallery-select]').forEach(button => button.addEventListener('click', () => {
    const gallery = button.closest('[data-gallery]');
    qsa('[data-gallery-panel]', gallery).forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.gallerySelect; });
    qsa('[data-gallery-select]', gallery).forEach(tab => { const active = tab === button; tab.setAttribute('aria-pressed', active); tab.classList.toggle('is-active', active); });
    document.dispatchEvent(new CustomEvent('lucy:gallery-changed'));
  }));
  const toggle = qs('.menu-toggle');
  const menu = qs('#MobileMenu');
  function closeMenu() { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Open menu'); }
  toggle?.addEventListener('click', () => { const expanded = toggle.getAttribute('aria-expanded') === 'true'; menu.hidden = expanded; toggle.setAttribute('aria-expanded', String(!expanded)); toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu'); });
  qsa('a', menu).forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) { closeMenu(); toggle.focus(); } });
  if (config.preview) {
    qsa('[data-checkout-form]').forEach(form => form.addEventListener('submit', event => {
      event.preventDefault(); qs('[data-cart-status]').textContent = 'Design preview: no payment is taken. The Shopify theme connects this button to your store’s secure checkout.';
    }));
    qsa('.newsletter-form, .contact-form').forEach(form => form.addEventListener('submit', event => {
      event.preventDefault(); let status = qs('[data-preview-status]', form);
      if (!status) { status = el('p'); status.dataset.previewStatus = ''; status.setAttribute('role', 'status'); form.append(status); }
      status.textContent = 'Design preview: your information has not been submitted.';
    }));
    if (new URLSearchParams(location.search).has('bag')) openBag();
  }
  const initialRevision = cartRevision;
  requestCart('cart.js').then(cart => { if (cartRevision === initialRevision) renderCart(cart); }).catch(() => { /* Native /cart navigation remains available. */ });
})();
